import styled from 'styled-components';

export const StyledProductCardPriceContainer = styled.div`
  .product-card-price-container {
    margin-bottom: 0;
  }
`;
